import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import AccountMappingUpdateModalUI from './AccountMappingUpdateModalUI.js'

// not used, need to modify to use account mapping
class AccountMappingUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // category
      keywords: '',
      keywordsError: null,
      //
      credit: 'false',
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <AccountMappingUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // category
        keywords={this.state.keywords}
        onKeywordsChange={(event) => { this.setState({ keywords: event.target.value }) }}
        keywordsError={this.state.keywordsError}
        setKeywordsError={(error) => { this.setState({ keywordsError: error }) }}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (!this.props.selectedCategory)
      return
    if (!prevProps.selectedCategory || prevProps.selectedCategory.category !== this.props.selectedCategory.category) {
      this.setState({
        keywords: this.props.selectedCategory.keywords,
        errorList: null,
        submitted: false
      })
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.accountId}/clientTxnCats/${this.props.selectedCategory.category}`,
      this.onSubmitCallback, {
      keywords: this.state.keywords,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch (error.fieldName) {
        case 'keywords':
          this.setState({ keywordsError: error.message })
          break;
        case 'category':
          this.setState({ categoryError: error.message })
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

    if (this.state.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }
}

export default withRouter(AccountMappingUpdateModalSF)
